module.exports = __webpack_public_path__ + "static/media/CA.fdcc50bc.svg";